export const TBL_HEADERS = [
  {
    name: "Actions",
    variable: "",
  },
  {
    name: "Instrument Code",
    variable: "testName",
  },
  {
    name: "Drug Class",
    variable: "testType",
  },
  {
    name: "Specimen Type",
    variable: "resultMethod",
  },
  {
    name: "QC Level",
    variable: "testCode",
  },
  {
    name: "Target",
    variable: "orderCode",
  },
  {
    name: "Calculation",
    variable: "tmitCode",
  },
];
